import { Box, Button, TextField, useTheme } from "@mui/material";
import React, { ChangeEvent, FormEvent, useEffect } from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { AppNotificationTypeEnum } from "../../contexts/app-notification-context/AppNotificationContextTypes";
import { useAppNotificationContext } from "../../contexts/app-notification-context/UseAppNotificationContext";
import LoginDataService from "../../services/login-data-service/LoginDataService";
import { RestError } from "../../services/rest-service/RestService";

import useForgotPasswordState from "./ForgotPasswordFormState";

export type ForgotPasswordFormProps = {
    visible: boolean,
    userName: string,
    onClose: () => void;
}

export default function ForgotPasswordForm({visible, userName, onClose}: ForgotPasswordFormProps) {

    const { t } = useTranslation();
    
    const theme = useTheme();

    const {email, setEmail, valid} = useForgotPasswordState(userName);
    const [,setAppNotificationState] = useAppNotificationContext();    
    
    let emailField = useRef<HTMLInputElement>(null);
    let submitButton = useRef<HTMLButtonElement>(null);

    const onEmailChanged = (event: ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value.trim());
    };

    const onForgotPassword = async (event: FormEvent<HTMLFormElement>) => { 
        event.preventDefault();
        try {
            await LoginDataService.sendForgotPassword(email);

            setAppNotificationState({
                notificationType: AppNotificationTypeEnum.Info,
                message: t('login.forgotPasswordSent'),
                show: true
            });

            onClose();            

        } catch(error) {

            const err = error as RestError;
                        
            setAppNotificationState({
                notificationType: AppNotificationTypeEnum.Error,
                message: err.message,
                show: true,
                error: err
            });
        }
    };

    const onBack = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        onClose();
    };

    useEffect(() => {
        submitButton?.current?.focus();
    }, [submitButton])

        return (
        <form style={{display: visible ? 'block': 'none', marginTop: theme.spacing(1), width: '100%'}}
            noValidate
            onSubmit={onForgotPassword} >

            <Box sx={{    
                display: 'flex',
                flexDirection: 'column'
            }}>

                <TextField
                    id="forgotemail"
                    name="forgotemail"
                    data-testid="forgotemail"
                    inputRef={emailField}
                    value={email}
                    margin="normal"
                    required
                    fullWidth
                    label={t("login.emailAddress")}
                    autoComplete="email"
                    autoFocus
                    variant="filled"
                    onChange={onEmailChanged} />

                <Button
                    name="sendinfo"
                    ref={submitButton}
                    disabled={!valid}
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="secondary"
                    sx={{
                        margin: theme.spacing(3, 0, 2)
                    }}>
                        { t("login.sendLoginInfo") }
                </Button>

                <Button
                    name="backtologin"
                    fullWidth
                    variant="contained"
                    onClick={onBack} >
                        { t("buttons.back") }
                </Button>
            </Box>
            
        </form>
    );
  }
